import { HeaderState } from './../../models/rootState.model';
import { createSelector, createFeatureSelector } from "@ngrx/store";


export const selectHeaderState = createFeatureSelector<HeaderState>('header');
export const selectHeaderBackbutton = createSelector(selectHeaderState, (state) => state.backbutton);
export const selectHeaderEnabled = createSelector(selectHeaderState, (state) => state.enabled);
export const selectHeaderTitle = createSelector(selectHeaderState, (state) => state.title);
export const selectHeaderVisible = createSelector(selectHeaderState, (state) => state.visible);
export const selectHeaderMainMenu = createSelector(selectHeaderState, (state) => state.mainMenu);
export const selectHeaderSideMenu = createSelector(selectHeaderState, (state) => state.sideMenu);
export const selectHeaderAlertVisible = createSelector(selectHeaderState, (state) => state.alert_visible);
export const selectHeaderElevation = createSelector(selectHeaderState, (state) => state.elevation);

export const selectHeaderContextMenuButtonVisible = createSelector(selectHeaderState, (state) => state.contextMenuButtonVisible);



